import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { utils } from '@atlaskit/util-service-support';
import { MarkRequestReadState } from '@atlassian/notification-common/types';
import { packageName, packageVersion } from '../constants';
export var markAllApiRoute = '/gateway/api/notification-log/api/3/notifications/mark';
export var markAllNotificationsReadFetch = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(direct, afterInclusive) {
    var requestServiceOptions;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          requestServiceOptions = {
            queryParams: {
              direct: direct,
              afterInclusive: afterInclusive
            },
            requestInit: {
              credentials: 'include',
              headers: {
                'content-type': 'application/json',
                'x-app-name': packageName,
                'x-app-version': packageVersion,
                'x-app-platform': 'web'
              },
              method: 'POST',
              body: JSON.stringify({
                toState: MarkRequestReadState.READ
              })
            },
            // @ts-ignore
            ignoreResponsePayload: true
          };
          _context.next = 3;
          return utils.requestService({
            url: markAllApiRoute
          }, requestServiceOptions);
        case 3:
          return _context.abrupt("return", _context.sent);
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function markAllNotificationsReadFetch(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();